import {IndexLink, Link} from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';

const getAriaCurrProps = (isCurrent) => isCurrent ? { 'aria-current': 'page' } : {};

const NavLinks = ({items, toggleMenu}) => {
  const currentPath = window.location.pathname;
  const closeMenu = () => {
    if (toggleMenu) {
      toggleMenu();
    }
  }
  return (
    <ul className="nav-links">
      <li><IndexLink to='/' activeClassName="active" onClick={closeMenu} {...getAriaCurrProps(currentPath === '/')}>Home</IndexLink></li>
      {items.map((x, index) => {
        if (x.external) {
          return <li key={index}><a href={x.link} target="_blank" onClick={closeMenu} dangerouslySetInnerHTML={{__html: x.label }} /></li>
        }
        return (
          <li key={index}><Link to={x.link} {...getAriaCurrProps(x.link === currentPath)} onClick={closeMenu} activeClassName="active" dangerouslySetInnerHTML={{__html: x.label }} /></li>
        )
      })}
    </ul>
  );
};

NavLinks.propTypes = {
  items: PropTypes.array.isRequired,
  toggleMenu: PropTypes.func
}

export default NavLinks;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/nav-links.js